import type { CmsProps } from '../../types/cms'
import styled from '@emotion/styled'
import { Box } from '@mui/material'
import { resizeImage } from '../../utils/resizeImage'

export const StyledImageSeparator = styled(Box)<CmsProps>`
  background: ${({ url }) => `url(${url}) center center no-repeat`};
  background-size: cover;
  width: 100%;
  height: ${({ height }) => `${resizeImage(Number(height ?? 0))}px`};
`
